module.exports = __webpack_public_path__ + "img/iniciar-curso.457999c4.webp";